import { createAction } from "redux-act";
export const FETCH_STATE_LIST = "FETCH_STATE_LIST";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";

export const fetchState = createAction(FETCH_STATE_LIST);
export const fetchStateFailed = createAction(FETCH_STATE_FAILED);
export const fetchStateSuccess = createAction(FETCH_STATE_SUCCESS);
